(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-ap-set-panel-options', actionFunc);

    function actionFunc($q, lodash, PanelManager) {
        return function(panel, options) {
            return $q.when(run());

            function run() {
                const panel_id = lodash.get(options, 'panel_id', null);
                const data = lodash.get(options, 'data', null);
                if (!panel_id || !data) {
                    return false;
                }

                const panel = PanelManager.get(panel_id);
                if (!panel) {
                    return false;
                }

                panel.setOptions(data);
                return true;
            }
        };
    }
})();